import axios from "axios";
import React, { Component } from "react";
import { toast } from "react-toastify";
import {
  Card,
  CardBody,
} from "reactstrap";
import Latex from "./Latex";
import Chip from "@material-ui/core/Chip";
import Spinner from "../../sample/spinner";
class LearnerAssesment extends Component {
  constructor(props) {
    super(props);
    const alldata = [];
    this.state = {
      alldata,
      showComponent: true,
    };
  }
  componentDidMount() {
    this.getLearnerOutlineAssesment();
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.contentType !== this.props.contentType ||
      prevProps.contentId !== this.props.contentId
    ) {
      this.getLearnerOutlineAssesment();
    }
  }
  getLearnerOutlineAssesment() {
    let formData = new FormData();
    formData.append("cofflearn", localStorage.getItem("state"));
    formData.append("contentid", this.props.contentId);
    axios
      .post("LearnerCourse/getLearnerOutlineAssesment", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          console.log(res.data);
          this.setState({ alldata: res.data, showComponent: false });
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }
  render() {
    return (
      <div>
        {this.state.showComponent === true ? (
          <>
            <Spinner />
          </>
        ) : (
          <center>
              <br/>
              <Chip
                        label={<><b>{"Outline :" +  this.state.alldata?.courseoutline}</b></>}
                        color="primary"
                        variant="outlined"
                      />
                      <br/>
            <div className="row p-3">
              <div class="table-responsive p-3">
                <Card>
                  <CardBody className="tab-border-color">
                    <table class="table table-striped table-hover bg-white">
                      <thead>
                        <tr class="text-center table-tr-color">
                          <th>MCQ</th>
                          <th>Project</th>
                          <th>HandsOn</th>
                          <th>MatchPair</th>
                          <th>FillTheGap</th>
                          <th>Marks</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="content-size">
                          <td>
                            {this.state.alldata?.mcq}/
                            {this.state.alldata?.totalmcq}
                          </td>
                          <td>
                            {this.state.alldata?.project}/
                            {this.state.alldata?.totalproject}
                          </td>
                          <td>
                            {this.state.alldata?.handson}/
                            {this.state.alldata?.totalhandson}
                          </td>
                          <td>
                            {this.state.alldata?.matchthepair}/
                            {this.state.alldata?.totalmatchthepair}
                          </td>
                          <td>
                            {this.state.alldata?.multiwordanswer}/
                            {this.state.alldata?.totalmultiwordanswer}
                          </td>
                          <td>
                            {this.state.alldata?.marksobtained}/
                            {this.state.alldata?.marksoutof}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
              <div class="table-responsive p-3">
                <table class="table table-striped table-hover bg-white">
                  <thead>
                    <tr class=" text-center table-tr-color">
                      <th>Sr.No</th>
                      <th>Assignment</th>
                      <th>Type</th>
                      <th>Topic/Unit</th>
                      <th>Marks Obtain</th>
                      <th>Issubmitted</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.alldata.questions.map((item, indexitem) => (
                      <tr class="content-size">
                        <td>{indexitem + 1}</td>
                        <td>
                        {item.assignment_text.length > 100 ?
                        <>
                          <Latex>
                            {" "}
                           <b><span
                              dangerouslySetInnerHTML={{
                                __html: item.assignment_text.substring(0, 100)+"...",
                              }}
                            /></b> 
                          </Latex>
                          </>:<>
                          <Latex>
                          {" "}
                         <b><span
                            dangerouslySetInnerHTML={{
                              __html: item.assignment_text.substring(0, 100),
                            }}
                          /></b> 
                        </Latex> </>}
                        </td>
                        <td>{item.type}</td>
                        <td>{item.topic}</td>
                        <td>
                          {item.weightage === null || item.weightage === 0 ? (
                            "Non Graded"
                          ) : (
                            <>
                              {item.marksobtain} / {item.weightage}
                            </>
                          )}
                        </td>
                        <td>{item.issubmitted}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </center>
        )}
      </div>
    );
  }
}

export default LearnerAssesment;
